import api from './api';

const permissionsApi = {
  // Vérifier accès à une page
  checkAccess: (page) => {
    return api.get(`/permissions/check/${page}`);
  },

  // Pages accessibles à l'utilisateur courant (pour les sélecteurs)
  getMyPages: () => {
    return api.get('/permissions/my-pages');
  },

  // Masquage d'une page sur un compte super-administrateur
  masquer:   (page, userId) => api.post(`/permissions/${page}/masquer`, { user_id: userId }),
  demasquer: (page, userId) => api.delete(`/permissions/${page}/masquer/${userId}`),

  // Liste des utilisateurs avec permissions pour une page
  getPagePermissions: (page) => {
    return api.get(`/permissions/${page}`);
  },

  // Accorder permissions
  grant: (page, data) => {
    return api.post(`/permissions/${page}/grant`, data);
  },

  // Modifier permissions
  update: (id, data) => {
    return api.put(`/permissions/${id}`, data);
  },

  // Révoquer permissions
  revoke: (page, userId) => {
    return api.delete(`/permissions/${page}/revoke/${userId}`);
  },

  // Toutes les permissions d'un utilisateur
  getUserPermissions: (userId) => {
    return api.get(`/permissions/by-user/${userId}`);
  }
};

export default permissionsApi;
